import { render, staticRenderFns } from "./batchUploadCompany.vue?vue&type=template&id=63859db6&scoped=true"
import script from "./batchUploadCompany.vue?vue&type=script&lang=js"
export * from "./batchUploadCompany.vue?vue&type=script&lang=js"
import style0 from "./batchUploadCompany.vue?vue&type=style&index=0&id=63859db6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63859db6",
  null
  
)

export default component.exports